{
  "opensInNewTab": " se abre en una pestaña nueva"
}
